// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://mega.etherscan.io/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://mega.etherscan.io/address/0x8126eAd44383cb52Cf6A1bb70F1b4d7399DE34ef
export const PROTOCOL_GUARDIAN = '0x8126eAd44383cb52Cf6A1bb70F1b4d7399DE34ef';

export const CHAIN_ID = 4326;
